import {} from '../actions/accounts';

export interface IAccountsState {
  network?: string;
  address?: string;
  enabled: boolean;
}

const defaultAccountsState = {
  enabled: false,
};

const accountsReducer = (
  state: IAccountsState = defaultAccountsState,
  action: any
) => {
  switch (action.type) {
  default:
    return state;
  }
};

export default accountsReducer;
